import React, { useState } from 'react';

const Tooltip = ({ children, text, position = "top" }) => {
  const [isVisible, setIsVisible] = useState(false);

  const tooltipClass = position === "bottom" 
    ? "top-full mt-2"
    : "bottom-full mb-2";

  const arrowClass = position === "bottom"
    ? "bottom-full -mb-1 border-b-gray-900"
    : "top-full -mt-1 border-t-gray-900";

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        {children}
      </div>
      {isVisible && (
        <div className={`absolute left-1/2 transform -translate-x-1/2 ${tooltipClass} px-3 py-1 text-sm text-white bg-gray-900 rounded-lg whitespace-nowrap`}>
          {text}
          <div className={`absolute left-1/2 transform -translate-x-1/2 ${arrowClass}`}>
            <div className="border-4 border-transparent"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip; 